import { ContactRequestErrorCode } from './errorCodes';
import { contactRequestErrorMessages } from './errorMessages';

export { ContactRequestErrorCode } from './errorCodes';
export { contactRequestErrorMessages } from './errorMessages';

interface ContactRequestErrorResult {
  errorCode: ContactRequestErrorCode;
  errorMessage: string;
}

function getMessage(code: ContactRequestErrorCode): string {
  return contactRequestErrorMessages[code];
}

export const handleContactRequestError = (
  status: number | undefined,
  data: unknown,
  isNetworkError?: boolean
): ContactRequestErrorResult => {
  if (isNetworkError) {
    return {
      errorCode: ContactRequestErrorCode.NETWORK_ERROR,
      errorMessage: getMessage(ContactRequestErrorCode.NETWORK_ERROR),
    };
  }
  if (status === 401) {
    return {
      errorCode: ContactRequestErrorCode.UNAUTHORIZED,
      errorMessage: getMessage(ContactRequestErrorCode.UNAUTHORIZED),
    };
  }
  if (status === 403) {
    return {
      errorCode: ContactRequestErrorCode.FORBIDDEN,
      errorMessage: getMessage(ContactRequestErrorCode.FORBIDDEN),
    };
  }
  if (status === 404) {
    return {
      errorCode: ContactRequestErrorCode.NOT_FOUND,
      errorMessage: getMessage(ContactRequestErrorCode.NOT_FOUND),
    };
  }
  if (status === 400 || status === 422) {
    if (data && typeof data === 'object') {
      const obj = data as { message?: string; error?: string };
      const msg = obj.error ?? obj.message;
      if (typeof msg === 'string' && msg.trim().length > 0) {
        return {
          errorCode: ContactRequestErrorCode.INVALID_TRANSITION,
          errorMessage: msg.trim(),
        };
      }
    }
    return {
      errorCode: ContactRequestErrorCode.VALIDATION_ERROR,
      errorMessage: getMessage(ContactRequestErrorCode.VALIDATION_ERROR),
    };
  }
  if (data && typeof data === 'object') {
    const obj = data as { message?: string; error?: string };
    const msg = obj.error ?? obj.message;
    if (typeof msg === 'string' && msg.trim().length > 0) {
      return {
        errorCode: ContactRequestErrorCode.UNKNOWN,
        errorMessage: msg.trim(),
      };
    }
  }
  return {
    errorCode: ContactRequestErrorCode.UNKNOWN,
    errorMessage: getMessage(ContactRequestErrorCode.UNKNOWN),
  };
};
